import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { saveDeal } from 'bundles/apex/deals/form/store/deal/actions';

import Button from 'shared/button';

export function DealFormSaveButton({ deal, saveDeal, onSave }) {
  return (
    <Button.Primary
      aria-label="Save Button"
      disabled={deal.saving}
      onClick={() => saveDeal(onSave)}
    >
      {deal.id ? 'Save' : 'Create'}
    </Button.Primary>
  );
}

DealFormSaveButton.propTypes = {
  deal: PropTypes.shape({
    id: PropTypes.number,
    saving: PropTypes.bool,
  }).isRequired,
  saveDeal: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

const mapDispatchToProps = {
  saveDeal,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealFormSaveButton);
